module.exports = " <div class=vc-indicator v-show=show> <toast center v-if=\"type === 'toast'\"> <circular :size=36 color=white></circular> <div class=toast-text v-if=text>{{text}}</div> </toast> <modal v-if=\"type === 'modal'\" hide-close :overlay=false show> <div class=vc-indicator-modal-content> <circular :size=36></circular> <div class=vc-indicator-modal-text v-if=text> {{text}} </div> </div> </modal> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/indicator/indicator.vue
 ** module id = 450
 ** module chunks = 1
 **/